export default "__VITE_ASSET__BR2u$nvg__"